import { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { UseFormReturn } from "react-hook-form";
import { FormControl, FormField, FormItem, FormMessage } from "../ui/form";
import { CompassIcon, GlobeIcon, XIcon } from "lucide-react";
import NationalitySelector from "../onboarding/data-form/NationalitySelector";
import { useTranslation } from "@/hooks/useTranslation";
import EthnicitySelector from "../onboarding/data-form/EthnicitySelector";
import { Button } from "../ui/button";

export function NationalityEthnicityFilter({
  form,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
}) {
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = sessionStorage.getItem("searchNationalityFilterActiveTab");
    return savedTab === "nationality" || savedTab === "ethnicity"
      ? savedTab
      : "nationality";
  });
  const t = useTranslation();

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    sessionStorage.setItem("searchNationalityFilterActiveTab", value);
  };

  useEffect(() => {
    const subscription = form.watch((value, { name }) => {
      if (
        name === "nationalities" &&
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        value.nationalities &&
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        value.nationalities.length > 0
      ) {
        form.setValue("ethnicity", null);
      } else if (
        name === "ethnicity" &&
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        value.ethnicity
      ) {
        form.setValue("nationalities", []);
      }
    });

    return () => subscription.unsubscribe();
  }, [form]);

  return (
    <Tabs value={activeTab} onValueChange={handleTabChange}>
      <TabsList className="w-full md:w-fit grid grid-cols-2">
        <TabsTrigger className="flex flex-row" value="nationality">
          <GlobeIcon className="w-4 h-4 mr-2" />
          {t.SEARCH_PAGE.LABELS.NATIONALITY}
        </TabsTrigger>
        <TabsTrigger className="flex flex-row" value="ethnicity">
          <CompassIcon className="w-4 h-4 mr-2" />
          {t.SEARCH_PAGE.LABELS.ETHNICITY}
        </TabsTrigger>
      </TabsList>
      <TabsContent value="nationality">
        <FormField
          control={form.control}
          name="nationalities"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <NationalitySelector
                  formField={field}
                  maxSelections={5}
                  placeholder={t.SEARCH_PAGE.PLACEHOLDERS.NATIONALITY_INPUT}
                />
              </FormControl>
              <FormMessage className="mt-1" />
            </FormItem>
          )}
        />
      </TabsContent>
      <TabsContent value="ethnicity">
        <FormField
          control={form.control}
          name="ethnicity"
          render={({ field }) => (
            <FormItem>
              <div className="flex flex-row gap-x-2">
                <FormControl>
                  <EthnicitySelector formField={field} />
                </FormControl>
                {field.value && (
                  <Button
                    className="rounded-full h-10 w-10"
                    variant="outline"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      form.setValue("ethnicity", null);
                    }}
                  >
                    <XIcon className="h-4 w-4 shrink-0" />
                  </Button>
                )}
              </div>
              <FormMessage className="mt-1" />
            </FormItem>
          )}
        />
      </TabsContent>
    </Tabs>
  );
}
